export const Animations = Symbol('Animations')

export const name = 'animations' as const
